import axios from "axios";
import type { LaborCostChartIn } from "@/pages/human-resources/time-management/endpoints/analysis/inout/LaborCostChartIn.ts";
import type { LaborCostChartData } from "@/pages/human-resources/time-management/business/analysis/LaborCostChartData.ts";

export async function getLaborCostChartData(
  params: LaborCostChartIn,
): Promise<LaborCostChartData> {
  const { data } = await axios.get<LaborCostChartData>(
    "/api/hr/schedule/analysis/laborcost/chart",
    {
      params,
    },
  );
  return data;
}

export const laborCostChartDataQueryKey = {
  all: ["schedule_analysis_labor_cost_chart_data"] as const,
  forSiteDateModeAndService: (params: LaborCostChartIn) =>
    [
      ...laborCostChartDataQueryKey.all,
      params.domainId,
      params.siteId,
      params.date,
      params.mode,
      params.range,
      params.serviceIndex,
    ] as const,
};
